var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconNow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13.891,
  height: 12.277,
  viewBox: "0 0 13.891 12.277",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1037",
  "data-name": "Group 1037",
  transform: "translate(-1221.585 -475.945)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1036",
  "data-name": "Group 1036",
  transform: "translate(1221.585 475.945)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2541",
  "data-name": "Path 2541",
  d: "M1221.747,475.945a.161.161,0,1,0,0,.323h1.827q1.263,3.146,2.519,6.3l-.782,1.878a.17.17,0,0,0,.151.227h8.077a.162.162,0,1,0,0-.323H1225.7l.682-1.631,7.976-.636a.166.166,0,0,0,.141-.121l.969-4.2a.169.169,0,0,0-.156-.2h-10.874l-.605-1.514a.166.166,0,0,0-.152-.1Zm2.827,1.938h3.8v2.1h-2.958Zm4.12,0h2.584v2.1h-2.584Zm2.907,0h3.514l-.485,2.1H1231.6Zm-6.057,2.423h2.827v1.928l-1.994.161Zm3.15,0h2.584V482l-2.584.207Zm2.907,0h2.953l-.338,1.464-2.615.207Zm-4.523,5.331a1.292,1.292,0,1,0,1.292,1.292A1.295,1.295,0,0,0,1227.078,485.637Zm4.846,0a1.292,1.292,0,1,0,1.292,1.292A1.295,1.295,0,0,0,1231.923,485.637Zm-4.846.323a.969.969,0,1,1-.969.969A.967.967,0,0,1,1227.078,485.96Zm4.846,0a.969.969,0,1,1-.969.969A.967.967,0,0,1,1231.923,485.96Z",
  transform: "translate(-1221.585 -475.945)",
  fill: "#119c4a"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_now.1044df71.svg";
export { ForwardRef as ReactComponent };